// SPA boot: session check, login screen, application shell (sidebar navigation, view-as banner,
// realtime status) and the hash router. Pages are registered by the page-*.js modules.
'use strict';
(function () {
  const { t, esc } = App;
  const root = document.getElementById('app');
  document.documentElement.lang = App.lang();

  // Sidebar order. Pages declare their nav entry via App.page(name, { nav: { group, order, icon } }).
  const NAV_GROUPS = [['main', null], ['admin', 'nav_admin']];

  App.onUnauthorized = () => {
    if (!App.me) return;
    App.me = null;
    App.ws.stop();
    renderLogin();
  };

  App.setViewAs = (user) => {
    App.viewAs = user && user.id ? { id: Number(user.id), username: String(user.username || user.id) } : null;
    if (App.viewAs) sessionStorage.setItem('viewAs', JSON.stringify(App.viewAs)); else sessionStorage.removeItem('viewAs');
    renderViewAs();
    App.navigate('#/');
    App.route();
  };

  App.setNavCount = (name, count) => {
    const el = document.querySelector(`[data-nav="${name}"] .count`);
    if (!el) return;
    el.textContent = count ? String(count) : '';
    el.classList.toggle('hidden', !count);
  };

  boot();

  async function boot() {
    const me = await App.api('/api/me');
    if (me.status === 200 && me.data.user) {
      App.me = me.data.user;
      await App.cat.load();
      startShell();
    } else {
      renderLogin();
    }
  }

  function langSelect(id) {
    const cur = App.lang();
    return `<select id="${id}" aria-label="${esc(t('language'))}">${App.LANGS.map(([code, name]) =>
      `<option value="${code}"${code === cur ? ' selected' : ''}>${esc(name)}</option>`).join('')}</select>`;
  }

  function renderLogin() {
    document.title = t('login') + ' · ' + t('brand');
    root.innerHTML = `<div class="auth-wrap"><form class="card auth-card" id="loginForm" novalidate>
      <div class="row between nowrap"><div class="brand"><b>${esc(t('brand'))}</b><span>${esc(t('login_sub'))}</span></div>${langSelect('loginLang')}</div>
      <div class="field"><label for="loginUser">${esc(t('username'))}</label><input id="loginUser" autocomplete="username" required autofocus></div>
      <div class="field"><label for="loginPass">${esc(t('password'))}</label><input id="loginPass" type="password" autocomplete="current-password" required></div>
      <div class="err" id="loginErr" role="alert"></div>
      <button class="btn primary block" type="submit">${esc(t('login_btn'))}</button>
    </form></div>`;
    App.$('#loginLang').onchange = (event) => App.setLang(event.target.value);
    App.$('#loginForm').onsubmit = async (event) => {
      event.preventDefault();
      const button = event.target.querySelector('button[type=submit]');
      button.disabled = true;
      const r = await App.api('/api/login', { method: 'POST', body: { username: App.$('#loginUser').value.trim(), password: App.$('#loginPass').value } });
      button.disabled = false;
      if (r.ok) { location.reload(); return; }
      App.$('#loginErr').textContent = r.data.err === 'invalid' ? t('e_invalid') : App.errorText(r.data);
    };
    setTimeout(() => { const u = App.$('#loginUser'); if (u) u.focus(); }, 0);
  }

  function navHtml() {
    const isAdmin = App.me.role === 'admin';
    let html = '';
    for (const [group, label] of NAV_GROUPS) {
      const entries = [...App.pages.values()].filter(p => p.nav && (p.nav.group || 'main') === group && (!p.admin || isAdmin))
        .sort((a, b) => (a.nav.order || 0) - (b.nav.order || 0));
      if (!entries.length && !(group === 'admin' && isAdmin)) continue;
      if (label) html += `<div class="nav-group">${esc(t(label))}</div>`;
      for (const p of entries) {
        html += `<a class="nav-item" href="#/${p.name === 'dashboard' ? '' : p.name}" data-nav="${p.name}">
          <span class="ico" aria-hidden="true">${p.nav.icon || '•'}</span><span>${esc(p.title ? p.title() : p.name)}</span>
          <span class="count badge info hidden"></span></a>`;
      }
      if (group === 'admin' && isAdmin) {
        html += `<a class="nav-item" href="/ide" target="_blank" rel="noopener"><span class="ico" aria-hidden="true">🧪</span><span>${esc(t('nav_ide'))}</span><span class="small faint" aria-hidden="true">↗</span></a>`;
      }
    }
    return html;
  }

  function renderViewAs() {
    const host = App.$('#viewAs');
    if (!host) return;
    if (!App.viewAs) { host.innerHTML = ''; host.className = 'hidden'; return; }
    host.className = 'view-as';
    host.innerHTML = `<span>👁 ${esc(t('view_as', App.viewAs.username))}</span><button class="btn sm secondary" id="viewAsExit">${esc(t('view_as_exit'))}</button>`;
    App.$('#viewAsExit').onclick = () => App.setViewAs(null);
  }

  function setConn(state) {
    const el = App.$('#connState');
    if (!el) return;
    const tone = state === 'live' ? 'ok' : state === 'reconnecting' ? 'warn' : 'info';
    el.innerHTML = `<span class="dot ${tone}"></span>${esc(t('conn_' + state))}`;
  }

  function startShell() {
    if (App.me.role === 'admin') {
      try { const saved = JSON.parse(sessionStorage.getItem('viewAs') || 'null'); if (saved && saved.id) App.viewAs = saved; } catch (_) {}
    }
    root.innerHTML = `<div class="shell">
      <aside class="sidebar" id="sidebar">
        <div class="brand"><b>${esc(t('brand'))}</b><span>${esc(t('brand_sub'))}</span></div>
        <nav class="stack tight" aria-label="${esc(t('nav_menu'))}">${navHtml()}</nav>
        <div class="sidebar-foot">
          <div class="conn-state" id="connState"></div>
          <div class="user-box"><span class="grow"><span class="name">${esc(App.me.username)}</span>
            <span class="small muted"> · ${esc(t(App.me.role === 'admin' ? 'role_admin' : 'role_user'))}</span></span></div>
          <div class="row nowrap" style="padding:0 10px">${langSelect('shellLang')}<button class="btn sm ghost" id="logoutBtn">${esc(t('logout'))}</button></div>
        </div>
      </aside>
      <div class="main">
        <div class="topbar"><button class="btn icon ghost" id="menuBtn" aria-label="${esc(t('nav_menu'))}">☰</button><b>${esc(t('brand'))}</b></div>
        <div id="viewAs" class="hidden"></div>
        <main id="page"></main>
      </div>
    </div>`;
    App.$('#shellLang').onchange = (event) => App.setLang(event.target.value);
    App.$('#logoutBtn').onclick = async () => { await App.api('/api/logout', { method: 'POST' }); sessionStorage.removeItem('viewAs'); location.reload(); };
    App.$('#menuBtn').onclick = () => document.body.classList.toggle('nav-open');
    document.addEventListener('click', (event) => {
      if (document.body.classList.contains('nav-open') && !event.target.closest('#sidebar') && !event.target.closest('#menuBtn')) document.body.classList.remove('nav-open');
    });
    renderViewAs();
    App.ws.on('status', ({ state }) => setConn(state));
    setConn(App.ws.state());
    App.ws.start();
    window.addEventListener('hashchange', App.route);
    App.route();
  }
})();
